// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
export var AssetType;
(function (AssetType) {
    AssetType["ASSET_TYPE_INVALID"] = "ASSET_TYPE_INVALID";
    AssetType["PHONE_NUMBER"] = "PHONE_NUMBER";
    AssetType["DEPARTMENT"] = "DEPARTMENT";
    AssetType["DEVICE"] = "DEVICE";
    AssetType["VOICEMAIL_BOX"] = "VOICEMAIL_BOX";
    AssetType["MEDIA_LIBRARY"] = "MEDIA_LIBRARY";
    AssetType["EMAIL_ADDRESS"] = "EMAIL_ADDRESS";
    AssetType["FORMS_LIBRARY"] = "FORMS_LIBRARY";
    AssetType["FORMS_SUBMISSION"] = "FORMS_SUBMISSION";
    AssetType["STRIPE_ACCOUNT"] = "STRIPE_ACCOUNT";
    AssetType["SUNBIT_ACCOUNT"] = "SUNBIT_ACCOUNT";
    AssetType["MARKETING_LIBRARY"] = "MARKETING_LIBRARY";
    AssetType["FACEBOOK_PAGE"] = "FACEBOOK_PAGE";
    AssetType["GOOGLE_BUSINESS"] = "GOOGLE_BUSINESS";
    AssetType["INTEGRATION"] = "INTEGRATION";
    AssetType["DATASET"] = "DATASET";
    AssetType["SOURCE"] = "SOURCE";
    AssetType["SOURCE_TENANT"] = "SOURCE_TENANT";
    AssetType["PATIENT_PROFILE"] = "PATIENT_PROFILE";
    AssetType["INSURANCE_VERIFICATION"] = "INSURANCE_VERIFICATION";
    AssetType["SCHEDULE"] = "SCHEDULE";
    AssetType["PHONE_TENANT"] = "PHONE_TENANT";
    AssetType["INBOX"] = "INBOX";
    AssetType["AUTO_MESSAGING_RULE"] = "AUTO_MESSAGING_RULE";
    AssetType["MESSAGING_TEMPLATE"] = "MESSAGING_TEMPLATE";
    AssetType["BULK_EMAIL_CAMPAIGN_COLLECTION"] = "BULK_EMAIL_CAMPAIGN_COLLECTION";
    AssetType["BULK_TEXT_CAMPAIGN_COLLECTION"] = "BULK_TEXT_CAMPAIGN_COLLECTION";
    AssetType["BULK_EMAIL_CAMPAIGN_TEMPLATE"] = "BULK_EMAIL_CAMPAIGN_TEMPLATE";
    AssetType["IMAGE_GALLERY_ITEM"] = "IMAGE_GALLERY_ITEM";
    AssetType["AUTO_MESSAGING_EMAIL_TEMPLATE"] = "AUTO_MESSAGING_EMAIL_TEMPLATE";
    AssetType["REFERENCE"] = "REFERENCE";
})(AssetType || (AssetType = {}));
export var AssetType_index;
(function (AssetType_index) {
    AssetType_index[AssetType_index["ASSET_TYPE_INVALID"] = 0] = "ASSET_TYPE_INVALID";
    AssetType_index[AssetType_index["PHONE_NUMBER"] = 1] = "PHONE_NUMBER";
    AssetType_index[AssetType_index["DEPARTMENT"] = 2] = "DEPARTMENT";
    AssetType_index[AssetType_index["DEVICE"] = 3] = "DEVICE";
    AssetType_index[AssetType_index["VOICEMAIL_BOX"] = 4] = "VOICEMAIL_BOX";
    AssetType_index[AssetType_index["MEDIA_LIBRARY"] = 5] = "MEDIA_LIBRARY";
    AssetType_index[AssetType_index["EMAIL_ADDRESS"] = 7] = "EMAIL_ADDRESS";
    AssetType_index[AssetType_index["FORMS_LIBRARY"] = 8] = "FORMS_LIBRARY";
    AssetType_index[AssetType_index["FORMS_SUBMISSION"] = 9] = "FORMS_SUBMISSION";
    AssetType_index[AssetType_index["STRIPE_ACCOUNT"] = 10] = "STRIPE_ACCOUNT";
    AssetType_index[AssetType_index["SUNBIT_ACCOUNT"] = 11] = "SUNBIT_ACCOUNT";
    AssetType_index[AssetType_index["MARKETING_LIBRARY"] = 12] = "MARKETING_LIBRARY";
    AssetType_index[AssetType_index["FACEBOOK_PAGE"] = 13] = "FACEBOOK_PAGE";
    AssetType_index[AssetType_index["GOOGLE_BUSINESS"] = 14] = "GOOGLE_BUSINESS";
    AssetType_index[AssetType_index["INTEGRATION"] = 15] = "INTEGRATION";
    AssetType_index[AssetType_index["DATASET"] = 17] = "DATASET";
    AssetType_index[AssetType_index["SOURCE"] = 28] = "SOURCE";
    AssetType_index[AssetType_index["SOURCE_TENANT"] = 29] = "SOURCE_TENANT";
    AssetType_index[AssetType_index["PATIENT_PROFILE"] = 18] = "PATIENT_PROFILE";
    AssetType_index[AssetType_index["INSURANCE_VERIFICATION"] = 19] = "INSURANCE_VERIFICATION";
    AssetType_index[AssetType_index["SCHEDULE"] = 20] = "SCHEDULE";
    AssetType_index[AssetType_index["PHONE_TENANT"] = 21] = "PHONE_TENANT";
    AssetType_index[AssetType_index["INBOX"] = 6] = "INBOX";
    AssetType_index[AssetType_index["AUTO_MESSAGING_RULE"] = 22] = "AUTO_MESSAGING_RULE";
    AssetType_index[AssetType_index["MESSAGING_TEMPLATE"] = 23] = "MESSAGING_TEMPLATE";
    AssetType_index[AssetType_index["BULK_EMAIL_CAMPAIGN_COLLECTION"] = 24] = "BULK_EMAIL_CAMPAIGN_COLLECTION";
    AssetType_index[AssetType_index["BULK_TEXT_CAMPAIGN_COLLECTION"] = 25] = "BULK_TEXT_CAMPAIGN_COLLECTION";
    AssetType_index[AssetType_index["BULK_EMAIL_CAMPAIGN_TEMPLATE"] = 26] = "BULK_EMAIL_CAMPAIGN_TEMPLATE";
    AssetType_index[AssetType_index["IMAGE_GALLERY_ITEM"] = 27] = "IMAGE_GALLERY_ITEM";
    AssetType_index[AssetType_index["AUTO_MESSAGING_EMAIL_TEMPLATE"] = 30] = "AUTO_MESSAGING_EMAIL_TEMPLATE";
    AssetType_index[AssetType_index["REFERENCE"] = 99999] = "REFERENCE";
})(AssetType_index || (AssetType_index = {}));
